// import React, { Suspense, lazy } from 'react';
// import PropTypes from 'prop-types';

// // Lazy-load PaymentOption component
// const PaymentOption = lazy(() =>
//   import('../../../components/AccountSettings/PaymentOptions/PaymentOption').catch(() => ({
//     default: () => <div role="alert">Error loading payment options</div>,
//   }))
// );

// // Error Boundary Component
// class ErrorBoundary extends React.Component {
//   state = { hasError: false, error: null };

//   static getDerivedStateFromError(error) {
//     return { hasError: true, error };
//   }

//   componentDidCatch(error, errorInfo) {
//     if (process.env.NODE_ENV === 'production') {
//       // Example: Log to Sentry or another service
//       console.error('ErrorBoundary caught:', error, errorInfo);
//     }
//   }

//   render() {
//     if (this.state.hasError) {
//       return (
//         <div className="error-message" role="alert">
//           Error: Unable to load payment options
//           {process.env.NODE_ENV === 'development' && (
//             <pre>{this.state.error?.message}</pre>
//           )}
//         </div>
//       );
//     }
//     return this.props.children;
//   }
// }

// // Memoized component to prevent unnecessary re-renders
// const PaymentOptionWrapper = React.memo(({ userId, ...props }) => (
//   <ErrorBoundary>
//     <Suspense fallback={<div aria-live="polite">Loading payment options...</div>}>
//       <PaymentOption userId={userId} {...props} />
//     </Suspense>
//   </ErrorBoundary>
// ));

// // Prop validation
// PaymentOptionWrapper.propTypes = {
//   userId: PropTypes.string, // Assuming PaymentOption expects a userId prop
// };

// // Default props (optional, depending on requirements)
// PaymentOptionWrapper.defaultProps = {
//   userId: null,
// };

// export default PaymentOptionWrapper;

import React from 'react'
import PaymentOption from '../../../components/AccountSettings/PaymentOptions/PaymentOption';

const paymentOption = () => {
    return (
        <div>
            <PaymentOption />
        </div>
    )
}

export default paymentOption